// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input/Input';
import { Spoiler } from './../../components/ui';
import Grid, { GridItem } from './../../components/layout/Grid';
import { Card, Filter } from './../../components';
const {
  Field
} = Card;
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-1fe8rks-0"
})(["padding:16px;"]);
const Buttons = styled(GridItem).withConfig({
  displayName: "Filter__Buttons",
  componentId: "sc-1fe8rks-1"
})(["margin:0 -10px;& .ant-btn{margin:0 10px;}"]);
const StouFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) => <Spoiler label="Фильтр">
    <SpoilerContent>
      <Grid gutter="16px">
        <Filter initialValues={filter} cleanFilter={cleanFilter} applyFilter={applyFilter}>
          {({
          values,
          changeValue,
          cleanFilter,
          applyFilter
        }) => <>
              <GridItem>
                <Field label="Мнемокод">
                  <Input value={values.mnemonic} onChange={e => changeValue('mnemonic', e.target.value)} />
                </Field>
              </GridItem>
              <Buttons fullWidth>
                <Button type="primary" onClick={applyFilter}>
                  Применить
                </Button>
                <Button type="plain" onClick={cleanFilter}>
                  Очистить
                </Button>
              </Buttons>
            </>}
        </Filter>
      </Grid>
    </SpoilerContent>
  </Spoiler>;
export default StouFilter;
